import { SvgIcon, SvgIconProps } from "@mui/material";

const IconLeftToolbar = ({ ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.3077 27.5C11.8106 27.5 11.385 27.323 11.031 26.969C10.677 26.615 10.5 26.1894 10.5 25.6923V14.3077C10.5 13.8106 10.677 13.385 11.031 13.031C11.385 12.677 11.8106 12.5 12.3077 12.5H16V27.5H12.3077ZM17.5 27.5V12.5H27.6923C28.1894 12.5 28.615 12.677 28.969 13.031C29.323 13.385 29.5 13.8106 29.5 14.3077V25.6923C29.5 26.1894 29.323 26.615 28.969 26.969C28.615 27.323 28.1894 27.5 27.6923 27.5H17.5Z"
        fill="currentColor"
        color="#494949"
      />
    </SvgIcon>
  );
};
export default IconLeftToolbar;
